<template>
  <div style="margin: 0 auto;width: 100%;">
    <Header/>
    <AgencyRanking/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import AgencyRanking from './components/AgencyRanking'
import Footer from '../layout/Footer'
export default {
  components: {
    Header,
    AgencyRanking,
    Footer
  },
  data () {
    return {
      programId: Number(this.$route.query.programId)
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/ProgramAgency.vue